import React from 'react';
import './Features.css';

const items = [
  { title: 'Global Resource Aggregation', desc: 'Unites idle GPU servers from geographically distributed contributors into a federated compute pool, dramatically reducing LLM inference costs.', icon: '🌐' },
  { title: 'Multi-Model & Cross-Platform Support', desc: 'Compatible with hundreds of leading LLM models and support heterogeneous environment (Nvidia, AMD, Ascend, and Apple Metal on Windows, macOS, and Linux)', icon: '🧩' },
  { title: 'Intelligent Distributed LLM Deployment', desc: 'Leverages intelligent model splitting and task scheduling algorithms to autonomously determine the optimal distributed deployment strategy, minimizing inference latency.', icon: '🧠' },
  { title: 'PolyCoin Incentive Mechanism', desc: 'Contributors who provide their idle computational resources are rewarded with PolyCoin, creating a sustainable and incentivized ecosystem for distributed computing.', icon: '🪙' },
  { title: 'Open Collaborative Network', desc: 'Currently connected to 40+ GPUs across five universities (HK PolyU, HKUST, HKU, CUHK, and SCUT), fostering academic and compute power sharing.', icon: '🤝' }
];

const Features = () => (
  <section id="features" className="section features">
    <div className="container">
      <h2 className="section-title">PolyLink is an open AI computing infrastructure for <br/> LLMs inference</h2>
      <div className="features-grid">
        {items.map((it) => (
          <div key={it.title} className="feature-card">
            <div className="feature-icon">{it.icon}</div>
            <h3>{it.title}</h3>
            <p>{it.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
